import AxiosAPI from './AxiosAPI';

class Publisher extends AxiosAPI {
  getPublisherDetails(publisherUUID, limit, p) {
    return new Promise((resolve, reject) => {
      super.get(`v1/publishers/${publisherUUID}`, { limit, p }).then((res) => {
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPublisherDetailsBySlug(publisherSlug, limit, p) {
    return new Promise((resolve, reject) => {
      super.get(`v1/publishers/slug/${publisherSlug}`, { limit, p }).then((res) => {
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  loadPublishers() {
    return new Promise((resolve, reject) => {
      super.getList('v1/publishers').then((res) => {
        resolve(res);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  loadPublisherPodcasts(publishers) {
    return new Promise((resolve, reject) => {
      super.getList('v1/publishers-uuids', { uuids: publishers }).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }
}

export default Publisher;



// WEBPACK FOOTER //
// ./app/src/services/Publisher.js